import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { HttpParams } from "@angular/common/http";
import { Params, Router } from "@angular/router";
import Swal from "sweetalert2";
import { ReportsService } from "src/app/features/reports/reports.service";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { DialogComponent } from "src/app/features-common/components/dialog/dialog.component";
import { MatTabGroup } from "@angular/material/tabs";
import { CurrencyPipe, formatDate } from "@angular/common";
import * as moment from "moment";
import { AdminViewService } from "src/app/framework/services/admin-view.service";

@Component({
  selector: "app-loyalty-report",
  templateUrl: "./loyalty-report.component.html",
  styleUrls: ["./loyalty-report.component.scss"],
  providers: [CurrencyPipe],
})
export class LoyaltyReportComponent
  extends FeaturesBaseComponent
  implements OnInit
{
  @Input() loyality;
  @Input() summary;

  isRowSelected: boolean = false;
  searchValue: any;

  columnDefs: any;
  rowData: any = [];
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  isLogSelected: boolean;
  //summary:  Array<any>;
  isButtonDisabled:boolean

  minFromDate;
  maxDate;
  minToDate;
  startDate;
  endDate;

  constructor(
    private router: Router,
    private reportsService: ReportsService,
    private currencyPipe: CurrencyPipe,
    private adminViewServices:AdminViewService
  ) {
    super();
    this.setGrid();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["loyality"]) {
      this.loyality = changes["loyality"].currentValue;
      this.rowData = this.loyality;
    }
    if (changes["summary"]) {
      this.summary = changes["summary"].currentValue;
    }
  }

  setGrid() {
   
   
    this.columnDefs = [
      { field: "customerName", headerName: "Customer Name", width: 220 },
      {
        field: "customerMobileNumber",
        headerName: "Customer Mobile Number",
        width: 280,
      },
      { field: "customerEmail", headerName: "Customer Email", width: 210 },
      // { field: "country", headerName: "Country", width: 170 },
      { field: "retailerNumber", headerName: "Retailer Number", width: 210 },
      {
        field: "promoCodeGeneratedDate",
        headerName: "Promo Code Generated Date",
        width: 310,
        cellRenderer: (data) => {
          return data.value && data.value ? moment(data.value).format("MM/DD/YYYY") : '-' ;
        },
      },
      {
        field: "promoCodeSentDate",
        headerName: "Promo Code Sent Date",
        width: 280,
        cellRenderer: (data) => {
          return data.value && data.value ? moment(data.value).format("MM/DD/YYYY") : '-' ;
        },
      },
      {
        field: "promocodeReedemedDate",
        headerName: "Promo Code Redeemed Date",
        width: 320,
        cellRenderer: (data) => {
          return data.value && data.value ? moment(data.value).format("MM/DD/YYYY") : '-' ;
        },
      },
      {
        field: "promocodeEndDateTime",
        headerName: "Validity",
        width: 150,
        cellRenderer: (data) => {
          return data.value && data.value ? moment(data.value).format("MM/DD/YYYY") : '-' ;
        },
      },
    ];
    //this.rowData = []promoCodeGeneratedDate promoCodeSentDate promocodeReedemedDate promocodeEndDateTime
  }
  ngOnInit(): void {
    super.ngOnInit();
    this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })

  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  exportData() {
    let header = this.columnDefs.map((columnDef) => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: "Loyality-report.csv",
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs
        .map((c) => c.field || c.colId)
        .filter((c) => !!c),
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      // 
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if (
        (cellParams && cellParams.column.colId === "promoCodeGeneratedDate") ||
        cellParams.column.colId === "promoCodeSentDate" ||
        cellParams.column.colId === "promocodeReedemedDate" ||
        cellParams.column.colId === "promocodeEndDateTime"
      ) {
        return moment(cellParams.value).format("MM/DD/YYYY"); //apply your timestamp formatter
      } else return cellParams.value; // no formatting
    };
    this.gridApi.exportDataAsCsv(params);
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }
  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (
      this.selectedRows &&
      this.selectedRows != [] &&
      this.selectedRows.length! > 0
    ) {
      this.isLogSelected = true;
      return;
    }
    this.isLogSelected = false;
  }

  changeFromDate(e) {
    this.minToDate = e.value;
    this.startDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.endDate != null && this.endDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  changeToDate(e) {
    this.endDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.startDate != null && this.startDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  getDateChangeResult(startDate, endDate) {
    let params: any = new HttpParams()
      .set("startDate", startDate)
      .set("endDate", endDate);
    this.reportsService.getloyalitySummary(params).subscribe((res) => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.summary = resData;
        this.reportsService.getloyality(params).subscribe((res) => {
          let resData: any = res;
          if (resData.httpcode == 200) {
            resData = resData.data;
            this.setRowData(res["data"]);
            this.loyality = resData;
          }
        });
      }
    });
  }

  setRowData(rowData: any) {
    this.rowData = rowData;
  }
}
